import { getAnalyticsEnvironment } from '@src/config/env'
import { HTTP_HEADERS } from '@src/constants/common.constants'
import { getIsCountryCompliant } from '@src/modules/global-state/locale-config.browser'
import { FEATURES, MODULES } from '@src/quince-site-common/src/constants/template-info'
import { sgtmServiceClient } from '@src/quince-site-common/src/utils/HttpClient'
import { captureException } from '@src/quince-site-common/src/utils/sentryUtil'

import { getAppLovinTrackingData } from './utils/applovinTracking.utils'
import { processResponseHeaders } from './utils/handleSgtmApi.utils'
import { getOpenAITrackingData } from './utils/openai-tracking.utils'
import { getRedditTrackingData } from './utils/redditTracking.utils'
import { getSnapchatTrackingData } from './utils/snapchatTracking.utils'

export const handleSgtmApi = (
  eventData: Record<string, unknown>,
  event_name: string,
  event_key: string,
  shouldProcessResponseHeaders = false,
) => {
  // AppLovin, Snapchat and Reddit are not approved for UK.
  // Skip all three entirely for countryCompliant locales — no cookie reads,
  // no side effects, no SGTM payload fields.
  const isCountryCompliant = getIsCountryCompliant()
  const appLovinTrackingData = isCountryCompliant ? null : getAppLovinTrackingData()
  const snapchatTrackingData = isCountryCompliant ? null : getSnapchatTrackingData()
  const redditTrackingData = isCountryCompliant ? null : getRedditTrackingData()

  const openAITrackingData = getOpenAITrackingData()

  const enhancedEventData = {
    ...eventData,
    ...(redditTrackingData?.clickId && { click_id: redditTrackingData.clickId }),
    ...(redditTrackingData?.uuid && { uuid: redditTrackingData.uuid }),
    ...(appLovinTrackingData?.aleid && { aleid: appLovinTrackingData.aleid }),
    ...(appLovinTrackingData?.axwrt && { axwrt: appLovinTrackingData.axwrt }),
    ...(appLovinTrackingData?.alart && { alart: appLovinTrackingData.alart }),
    ...(snapchatTrackingData?.sc_click_id && { sc_click_id: snapchatTrackingData.sc_click_id }),
    ...(snapchatTrackingData?.sc_cookie1 && { sc_cookie1: snapchatTrackingData.sc_cookie1 }),
    ...(openAITrackingData.oppref && { oppref: openAITrackingData.oppref }),
    env: getAnalyticsEnvironment(),
  }

  const payload = {
    event: event_name,
    [event_key]: JSON.stringify(enhancedEventData),
  }

  const config = {
    headers: {
      [HTTP_HEADERS.CONTENT_TYPE]: HTTP_HEADERS.APPLICATION_JSON,
    },
  }

  sgtmServiceClient
    .post('/ecomm', payload, config)
    .then(res => {
      if (shouldProcessResponseHeaders) {
        // Type assertion to handle AxiosResponseHeaders type
        processResponseHeaders(res.headers as Record<string, string>)
      }
    })
    .catch((err: unknown) => {
      captureException(err, {
        module: MODULES.INTERNAL_ANALYTICS,
        feature: FEATURES.SGTM_API,
      })
    })
}
